export default "__VITE_PUBLIC_ASSET__32567417__"